export default __webpack_public_path__ + "static/media/caretDown.32f07811.svg";